<template>
  <div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu background-color="#304156" text-color="#bfcbd9" active-text-color="#409EFF" :default-active="activeMenu"
        :collapse="isCollapse" :unique-opened="false" :collapse-transition="false" mode="vertical" router>
        <el-menu-item :index="item.path" class="submenu-title-noDropdown" v-for="item in menus" :key="item.path">
          <i class="sub-el-icon" :class="[{iconfont:!item.icon.includes('el-')},item.icon]"></i>
          <span slot="title">{{item.title}}</span>
        </el-menu-item>
      </el-menu>
      <!-- <div @click="logout" class="logout">退出登录</div> -->
    </el-scrollbar>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import SidebarItem from './SidebarItem'
  // import variables from '@/styles/variables.less'

  export default {
    // components: { SidebarItem },
    data() {
      return {
        menus: [
          { title: '交易配置', path: '/config', icon: 'el-icon-s-tools' },
          { title: '机器人管理', path: '/robotList', icon: 'icon-robot' },
          { title: '带单管理', path: '/ordermanagement', icon: 'el-icon-s-order' },
        ],
      };
    },
    computed: {
      ...mapGetters([
        // 'permission_routes',
        'sidebar'
      ]),
      activeMenu() {
        const route = this.$route
        const { meta, path } = route
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      },
      // variables() {
      //   return variables
      // },
      isCollapse() {
        return !this.sidebar.opened
      }
    },
    // methods: {
    //   async logout() {
    //     await this.$store.dispatch('user/logout')
    //     this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    //   },
    // },
  }
</script>
<style lang="less" scoped>
  /* .logout{
    margin-top: 200px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    color: #fff;
    text-align: center;
  } */
</style>